import React from 'react'
import { HelpDrawerWithAccordion } from '@labrav/common'
import { landingPageImages } from '../../../common/utils/productCreationUtil'
import {
  FaqQuestion,
  FlyoutProductCreationFaqSection,
  HelpDrawerFaqItems,
} from '../FlyoutProductFormHelpFaqs/ProductCreationFaqUtil'
import { CarouselWithModal } from '../../../common/components/CarouselWithModal/CarouselWithModal'

const faqItems: HelpDrawerFaqItems[] = [
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.BUYER_REGISTRATION_REDIRECTION_SETTINGS
        }
        question="Why must I provide my Application Login Page URL?"
      />
    ),
    answer: (
      <div>
        If buyers can self-onboard, they should be redirected to your
        Application Login Page URL after submitting the registration form.
      </div>
    ),
  },
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.BUYER_REGISTRATION_REDIRECTION_SETTINGS
        }
        question="What is the application login page URL? "
      />
    ),
    answer: (
      <div>
        This is the link to the webpage where users can sign up and login to
        your application.
      </div>
    ),
  },
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.BUYER_REGISTRATION_REDIRECTION_SETTINGS
        }
        question="What are custom instructions?"
      />
    ),
    answer: (
      <div>
        You can provide your buyer with a brief on how they can onboard
        themselves in case your product allows it. This is basically to let your
        buyers know the next steps in order to gain access to your application.
      </div>
    ),
  },
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.BUYER_REGISTRATION_REDIRECTION_SETTINGS
        }
        question="Where will custom instructions show up?"
      />
    ),
    answer: (
      <div>
        The custom instructions provided by you will be attached in the email
        which this platform sends to your buyer after they submit the buyer
        registration page form.
      </div>
    ),
  },
]

interface FlyoutProductRedirectionSettingsFaqsProps {
  indexModal: number
  setIndexModal: (index: number) => void
}

export const FlyoutProductRedirectionSettingsFaqs: React.FC<
  FlyoutProductRedirectionSettingsFaqsProps
> = ({ indexModal, setIndexModal }) => (
  <HelpDrawerWithAccordion
    headerTitle="Help & FAQs - Redirection Settings"
    faqItems={faqItems}
    customContent={
      <CarouselWithModal
        carouselData={landingPageImages}
        setCurrentIndex={setIndexModal}
        currentIndex={indexModal}
      />
    }
  />
)
